/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { powDependencies } from './dependenciesPow.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createGamma } from '../../factoriesAny.js';
export var gammaDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  powDependencies: powDependencies,
  typedDependencies: typedDependencies,
  createGamma: createGamma
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesGamma.generated.js
// module id = 632
// module chunks = 0